import { Controller } from "@hotwired/stimulus"

// Clears the chosen value in a facet group and re-runs the search straight
// away, so the X control does not need the Apply filters button.
export default class extends Controller {
  clear() {
    this.element.querySelectorAll("input[type=radio]").forEach((radio) => { radio.checked = false })
    this.element.closest("form").requestSubmit()
  }
}
